const permissionList = [
  { item: '查看訂單列表', groupIds: [7, 10] },

  { item: '手動新增訂單', groupIds: [7, 10] },

  { item: '修改訂單', groupIds: [7, 10] },

  { item: '取消訂單與退款', groupIds: [7, 10] },

  { item: '入場報到', groupIds: [7, 10] },

  { item: '新增項目', groupIds: [7, 9] },

  { item: '修改項目內容／時段／方案', groupIds: [7, 9] },

  { item: '關閉項目／時段／方案', groupIds: [7, 9] },

  { item: '新增／修改項目人員', groupIds: [7, 9] },

  { item: '查看數據分析圖表', groupIds: [7, 8] },

  { item: '新增／修改管理帳號與其權限', groupIds: [7, 8] },

  { item: '修改商店資訊', groupIds: [7, 8] },

  { item: '方案訂閱管理', groupIds: [7] },

  { item: '金流申請設定', groupIds: [7] },

  { item: 'LINE bot 設定', groupIds: [7, 8] },
]

export default permissionList
